import { TypedDocumentNode, gql } from '@apollo/client';

import LoadingIndicator from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { WelcomeToTheTeam as WelcomeToTheTeamDumb } from '@sorare/core/src/components/cardswap/steps/WelcomeToTheTeam';
import { StepProps } from '@sorare/core/src/components/cardswap/types';
import { useCardSwapContext } from '@sorare/core/src/components/cardswap/useCardSwapContext';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';

import { CardSelection } from 'components/cardswap/CardSelection';

import {
  NBACardSwapFinalQuery,
  NBACardSwapFinalQueryVariables,
} from './__generated__/index.graphql';

const NBA_CARD_SWAP_FINAL_QUERY = gql`
  query NBACardSwapFinalQuery {
    currentUser {
      slug
      latestNBACardTrade {
        id
        userReceiveCard {
          slug
          ...CardSelection_NBACard
        }
        isComplete
      }
    }
  }
  ${CardSelection.fragments.NBACard}
` as TypedDocumentNode<NBACardSwapFinalQuery, NBACardSwapFinalQueryVariables>;

type Props = StepProps;

export const WelcomeToTheTeam = ({ nextStep, onClose }: Props) => {
  const { tradeId: cachedTradeId, clearCardSwapState } = useCardSwapContext();
  const { data } = useQuery(NBA_CARD_SWAP_FINAL_QUERY, {
    fetchPolicy: 'network-only',
  });

  if (!data) {
    return <LoadingIndicator />;
  }

  const trade = data.currentUser?.latestNBACardTrade;
  if (!trade?.userReceiveCard) {
    clearCardSwapState();
    return null;
  }

  const tradeId = trade.id;
  if (tradeId !== cachedTradeId) {
    clearCardSwapState();
    return null;
  }

  return (
    <WelcomeToTheTeamDumb
      renderCard={
        <CardSelection
          card={trade.userReceiveCard}
          isSelectable={false}
          larger
          shine
        />
      }
      nextStep={nextStep}
      onClose={onClose}
    />
  );
};
